import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./theme-switcher.module.scss";

const ThemeSwitcher: FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      className={`${styles.themeSwitcher} ${
        theme === "light" ? styles.light : ""
      }`}
      onClick={toggleTheme}
    >
      <div className={styles.switcherCircle}></div>
    </div>
  );
};

export default ThemeSwitcher;
